<header id="main-header ">
  <div class="header wk-row">
    <div class="header-encuesta">
      <app-btn-opinion></app-btn-opinion>
    </div>
    <div class="header-logo">
      <img
        class="bci-shapes wk-padding-top-24"
        src="./assets/images/bci-shapes.svg"
        alt="bci-shapes"
        [ngStyle]="iconStyle"
      />
      <div class="wk-padding-bottom-24">
        <h1 class="title">{{ title }}</h1>
        <h2 *ngIf="subtitle" class="subtitle">{{ subtitle }}</h2>
      </div>
    </div>
  </div>
</header>
